import React, {Component} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {observer, inject} from 'mobx-react'
import {Button} from 'antd'
import SaveModal from './SaveModal'

import style from './controls.sass'

@withRouter
@inject('store') @observer
class Controls extends Component {
  state = {
    modal: false,
    editing: false,
    preparingAlgo: false
  }
  update = () => {
    this.props.store.stockFilter.single.update()
  }
  updateAndBuild = () => {
    const {single} = this.props.store.stockFilter
    if (single.changed) {
      this.props.store.stockFilter.single.update(true)
    } else {
      const {screenerID} = this.props.match.params
      this.props.history.push({
        pathname: '/builder',
        query: {stock_filter:screenerID}
      })
    }
  }
  save = () => {
    this.setState({
      modal: true,
      editing: false,
      preparingAlgo: false
    })
  }
  saveAs = () => {
    this.setState({
      modal: true,
      editing: true,
      preparingAlgo: false
    })
  }
  buildAlgo = () => {
    this.setState({
      modal: true,
      editing: false,
      preparingAlgo: true
    })
  }
  closeModal = () => {
    this.setState({modal: false})
  }
  render(){
    const {permissions} = this.props.store
    const updateDisabled = !permissions.check('lab.screener.update')
    const createDisabled = !permissions.check('lab.screener.create')
    const filterExists = !!this.props.match.params.screenerID
    return(
      <div styleName='wrapper'>
        <SaveModal
          visible={this.state.modal}
          close={this.closeModal}
          editing={this.state.editing}
          preparingAlgo={this.state.preparingAlgo}
        />
        <div styleName='buttons'>
          <Button
            type='primary'
            icon='save'
            disabled={filterExists ? updateDisabled : createDisabled}
            onClick={filterExists ? this.update : this.save}
          >
            Save
          </Button>
          {filterExists &&
            <Button
              type='primary'
              icon='save'
              disabled={createDisabled}
              onClick={this.openModal}
            >
              Save as...
            </Button>
          }
          <Link to='/stock-filters'>
            <Button
              type='default'
              icon='close'
            >
              Cancel
            </Button>
          </Link>
        </div>
        <Button
          type='primary'
          styleName='build-algo-btn'
          onClick={filterExists ? this.updateAndBuild : this.buildAlgo}
        >
          Build Algo
        </Button>
      </div>
    )
  }
}

export default Controls
